import classNames from 'classnames/bind';
import React from 'react';
import { Helmet } from 'react-helmet';

import styles from './index.module.scss';
import Main from './Main';
import SideBar from './SideBar';

import ContainerFullHeight from '@/components/ui/ContainerFullHeight';
import TopBar from '@/components/ui/TopBar';
import useLoadRobots from '@/hooks/useLoadRobots';
import useLoadUser from '@/hooks/useLoadUser';

const cx = classNames.bind(styles);

const Page = () => {
  // 계정 조회
  useLoadUser();
  // 로봇내역 조회
  useLoadRobots();

  return (
    <>
      <Helmet>
        <title>M1UCS | Flight Review</title>
      </Helmet>
      <ContainerFullHeight className={cx('container')}>
        <TopBar />
        <div className={cx('content')}>
          <SideBar />
          <Main />
        </div>
      </ContainerFullHeight>
    </>
  );
};

export default Page;
